import { createContext, useContext } from "react";
import type { AnalyticsContextProps } from "../types/mainTypes";

/**
 * The analytics port: what the packages may ask of analytics. The provider that talks to Mixpanel,
 * Customer.io and CloudWatch belongs to the app (AnalyticsContextProvider); without one every call
 * is a no-op.
 */
export const AnalyticsContext = createContext<AnalyticsContextProps>({
	track: () => null,
	reset: () => null,
	identify: () => null,
	people: {
		set: () => null,
	},
});

/**
 * Retrieves the analytics context from the React Context API.
 *
 * @return {Object} The analytics context.
 */
export const useAnalyticsContext = () => useContext(AnalyticsContext);
